'use strict';

var _ = require('lodash');
var ActionQuery = function ActionQuery() {
  this._field = undefined;
  this._actionPart1 = undefined;
  this._actionPart2 = undefined;
  this._value = undefined;
  this._percent = undefined;
};
ActionQuery.prototype.field = function (field) {
  this._field = field;
  return this;
};
ActionQuery.prototype.action = function (type) {
  switch (type) {
    case 'Set':
      this._actionPart1 = 'set';
      this._actionPart2 = 'to';
      break;
    case 'Remove':
      this._actionPart1 = 'set';
      this._actionPart2 = 'to';
      this.value(null);
      break;
    case 'Increase by':
    case 'Increase by (Abs)':
      this._actionPart1 = 'increase';
      this._actionPart2 = 'by';
      break;
    case 'Increase by (%)':
      this._actionPart1 = 'increase';
      this._actionPart2 = 'by';
      this._percent = true;
      break;
    case 'Reduce by':
    case 'Reduce by (Abs)':
      this._actionPart1 = 'decrease';
      this._actionPart2 = 'by';
      break;
    case 'Reduce by (%)':
      this._actionPart1 = 'decrease';
      this._actionPart2 = 'by';
      this._percent = true;
      break;
    case 'Cumulative Increase by':
      this._actionPart1 = 'cumulative_increase';
      this._actionPart2 = 'by';
      break;
    case 'Cumulative Decrease by':
      this._actionPart1 = 'cumulative_decrease';
      this._actionPart2 = 'by';
      break;
    default:
      throw new Error('Invalid action type: ' + type);
  }
  return this;
};
ActionQuery.prototype.value = function (value) {
  this._value = value;
  return this;
};
ActionQuery.prototype.percent = function (value) {
  this.value(value);
  this._percent = true;
  return this;
};
function valueToString(value) {
  if (_.isArray(value)) {
    return '(' + _.map(value, valueToString).join(',') + ')';
  } else if (_.isString(value)) {
    return '\'' + value + '\'';
  } else if (_.isNumber(value)) {
    return value;
  } else {
    return value;
  }
}
ActionQuery.prototype.query = function () {
  if (this._field === undefined || this._value === undefined || this._actionPart1 === undefined || this._actionPart2 === undefined) {
    throw new Error('Invalid action');
  }
  var prefix = this._actionPart1 + ' ' + this._field + ' ' + this._actionPart2 + ' ';
  if (this._value || this._value === 0) {
    return prefix + valueToString(this._value) + (this._percent ? '%' : '');
  } else {
    return prefix + 'null';
  }
};
var ActionQueryFactory = function ActionQueryFactory() {
  return ActionQuery;
};
ActionQueryFactory.$inject = [];
module.exports = ActionQueryFactory;